export default __webpack_public_path__ + "static/media/juice-fruit-l-mobile@2x.6177e65e.png";